import { Component, OnInit, Input } from '@angular/core';
import { ScheduledEntry } from 'src/app/_interfaces';
import { ScheduleEntriesService, AppStringsService, RouteParserService } from 'src/app/_services';
import { SplideConfig } from 'src/app/_modules/carousel/splide-config';
import { Router } from '@angular/router';
import { CarouselComponent } from '../../carousel/carousel.component';
import { SlideComponent } from '../../carousel/slide/slide.component';
import { ScheduledEntryComponent } from '../../scheduled-entry/scheduled-entry.component';
import { SsrlocalstoreService } from 'src/app/_services/ssr-localstore.service';

@Component({
    selector: 'app-collection-entries',
    templateUrl: './collection-entries.component.html',
    styleUrls: ['./collection-entries.component.scss'],
    imports: [CarouselComponent, SlideComponent, ScheduledEntryComponent]
})
export class CollectionEntriesComponent implements OnInit {
    @Input() entry_type: string = ``;
    public header: string = ``;
    public entries: ScheduledEntry[] = [];

    constructor(
        private entriesService: ScheduleEntriesService,
        public appStringAPI: AppStringsService,
        private routeParser: RouteParserService,
        private router: Router,
        private ssr: SsrlocalstoreService
    ) { }

    get splideConfig() {
        return new SplideConfig().options({
            type: 'slide',
            perPage: 3,
            perMove: 1,
            gap: '1rem',
            arrows: true,
            fixedWidth: '225px'
        })
    }

    ngOnInit(): void {
        this.entriesService.entries.subscribe((entries) => {
            const map_event = {
                upcoming_entries: `upcoming`,
                completed_entries: `past`,
                past_partner_entries: `past_partner_events`
            }
            // TODO: Replace with GolfOne
            const header_map = {
                upcoming_entries: `tennisone.scores.section.header.upcoming.title`,
                completed_entries: `tennisone.scores.section.header.completed.title`,
                past_partner_entries: `tennisone.scores.section.header.completed.elite.title`
            }
            this.entries = entries[map_event[this.entry_type]];
            this.header = header_map[this.entry_type];
        })
    }

    routeLink(item: ScheduledEntry): void {
        // Save the teamId to use to end the tournament session in the next site launch/new total session 
        let sessions = JSON.parse(this.ssr.getItem('sessions') as string) || {};
        if (sessions?.tournament?.type) {
            sessions.tournament.team.id = item.team_id
            this.ssr.setItem('sessions', JSON.stringify(sessions))
        }
        const video_param = (
            item.theme?.play_video_ads ? `playad=true` :
                item.theme?.video_ad_id ? `playadwithid=${item.theme.video_ad_id}` : ``
        ).toLowerCase();
        const url = `bleachr://schedule/${item.team_id}/${item.id}?${video_param}`;

        if (item.theme?.play_video_ads || item.theme?.video_ad_id) {
            this.routeParser.parseBleachrRoutes(url);
        } else {
            this.router.navigate(['tournament', item.team_id, item.id]);
        }
    }

}
